import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Badge } from '@material-ui/core';
export const MBadge = forwardRef(({ color = 'default', children, sx, ...other }, ref) => {
    const theme = useTheme();
    if (color === 'default' || color === 'error' || color === 'primary' || color === 'secondary') {
        return (_jsx(Badge, Object.assign({ ref: ref, color: color, sx: sx }, other, { children: children }), void 0));
    }
    return (_jsx(Badge, Object.assign({ ref: ref, sx: {
            '& .MuiBadge-badge': {
                color: theme.palette[color].contrastText,
                backgroundColor: theme.palette[color].main,
            },
            ...sx,
        } }, other, { children: children }), void 0));
});
//# sourceMappingURL=MBadge.js.map